import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ItineraryInfoComponent } from './containers/itinerary-info/itinerary-info.component';
import { OperationLogComponent } from './containers/operation-log/operation-log.component';
import { SearchResultComponent } from './containers/search-result/search-result.component';
import { ItineraryGuard } from './guard/itinerary.guard';
import { OperationLogGuard } from './guard/operation-log.guard';
import { PnrHistoryComponent } from './containers/pnr-history/pnr-history.component';
import { PnrHistoryGuard } from './guard/pnr-history.guard';
import { AirCompanyNoteComponent } from './containers/air-company-note/air-company-note.component';
import { AirCompanyNoteGuard } from './guard/air-company-note.guard';
import { TicketHistoryComponent } from './containers/ticket-history/ticket-history.component';
import { TicketHistoryGuard } from './guard/ticket-history.guard';
import { AuthGuard } from '../auth/guards/auth.guard';
import { ItineraryHistoryComponent } from './containers/itinerary-history/itinerary-history.component';
import { ItineraryHistoryGuard } from './guard/itinerary-history.guard';

const routes: Routes = [
  {
    path: '',
    component: SearchResultComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'info'
      },
      {
        path: 'info',
        component: ItineraryInfoComponent,
        canActivate: [ItineraryGuard]
      },
      {
        path: 'operation-log',
        component: OperationLogComponent,
        canActivate: [OperationLogGuard]
      },
      {
        path: 'history',
        component: PnrHistoryComponent,
        canActivate: [PnrHistoryGuard]
      },
      {
        path: 'itineraryHistory',
        component: ItineraryHistoryComponent,
        canActivate: [ItineraryHistoryGuard]
      },
      {
        path: 'airCompanyNotes',
        component: AirCompanyNoteComponent,
        canActivate: [AirCompanyNoteGuard]
      },
      {
        path: 'ticketHistory',
        component: TicketHistoryComponent,
        canActivate: [TicketHistoryGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SearchResultRoutingModule {}
